exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-44453f69] .el-input-number .el-input__inner {\n  text-align: left;\n}", ""]);

// exports
